import React, { useState,useEffect} from 'react';
import axios from 'axios';
import { API_URL } from '../../api-config';

import AgentTable from './table';


const CreateAgent = () => {
  const [formData, setFormData] = useState({
    name: '',
    created_by: '',
    type: 'private',
    description: '',
    db_name: ''
  });
  const token = localStorage.getItem('token');
  const [dbList, setDbList] = useState([]);
  useEffect(()=> {
            axios.get(`${API_URL}/trading-api/agent/get_db_list`).then((response)=>{
                setDbList(response.data)
                setFormData({...formData, db_name: response.data[0]})
            })
  },[])

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_URL}/trading-api/agent/add_agent`, formData, {
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json',
          "Authorization": "Bearer " + token,
        }
      });
      console.log('Agent created successfully:', response.data);
      window.location.href = '/admin_panel';
    } catch (error) {
      console.error('Error creating agent:', error);
    }
  };

  return (
    <div className="flex  mt-10 px-10">
      <AgentTable/>
      
      <form onSubmit={handleSubmit} className="bg-trasparent  p-6 rounded-lg shadow-md w-1/2">
      <h1 className="text-2xl font-bold mb-6">Crear Agente</h1>
        <div className="mb-4 text-white" >
          <label htmlFor="name" className="block text-white font-bold mb-2">Name:</label>
          <input
            type="text"
            name="name"
            id="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 text-black rounded-md"
            required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="type" className="block text-white font-bold mb-2">Type:</label>
          <select
            name="type"
            id="type"
            value={formData.type}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 text-black rounded-md"
            required
          >
            <option value="private">Private</option>
            <option value="public">Public</option>
          </select>
        </div>
        <div className="mb-4">
          <label htmlFor="description" className="block text-white font-bold mb-2">Description:</label>
          <textarea
            name="description"
            id="description"
            value={formData.description}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 text-black rounded-md"
            required
          />
        </div>
        <div className="mb-4">
          <label htmlFor="db_name" className="block text-white font-bold mb-2">DB Name:</label>
          <select
            name="db_name"
            id="db_name"
            value={formData.db_name}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 text-black rounded-md"
            required
          >
            {dbList.map((db, index) => {
                return <option key={index} value={db}>{db}</option>
            })}

          </select>
        </div>
        <button
          type="submit"
          className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition duration-300"
        >
          Crear Agente
        </button>
      </form>
    </div>
  );
};

export default CreateAgent;
